import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const getDynamicColumnStyles = (
  head: string[][],
  body: any[][],
  pageWidth = 180
) => {
  const colCount = head[0].length;
  const maxLengths = new Array(colCount).fill(0);

  // 1. Get max character length for each column
  for (let col = 0; col < colCount; col++) {
    const headerLen = (head[0][col] || "").toString().length;
    const bodyLen = Math.max(
      ...body.map((row) => (row[col] || "").toString().length)
    );
    maxLengths[col] = Math.max(headerLen, bodyLen);
  }

  // 2. Calculate total content length
  const totalLength = maxLengths.reduce((acc, len) => acc + len, 0);

  // 3. Distribute available page width proportionally
  const columnStyles: Record<number, { cellWidth: number }> = {};
  maxLengths.forEach((len, i) => {
    const proportion = len / totalLength;
    const width = proportion * pageWidth;
    columnStyles[i] = { cellWidth: width };
  });

  return columnStyles;
};

class Export {
  private static filename = new Date().toDateString();

  constructor(export_as: string) {
    Export.filename = export_as;
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  exportToCSV = (data: any) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    const csvFile = XLSX.write(workbook, {
      bookType: "csv",
      type: "array",
    });

    saveAs(new Blob([csvFile], { type: "text/csv" }), Export.filename + ".csv");
  };

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  exportToExcel = (data: any) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    XLSX.writeFile(workbook, Export.filename + ".xlsx");
  };

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  exportToPDF = (data: any) => {
    const doc = new jsPDF();

    if (data.header) {
      for (let i = 0; i < data.header.length; i++) {
        let header = data.header[i];
        if (header.type == "image" && header.image) {
          doc.addImage(
            header.image,
            header.x,
            header.y,
            header.width,
            header.height
          );
        } else if (header.type == "text" && header.text) {
          if (header.fontStyle) {
            doc.setFont(header.fontStyle, header.fontVariant);
          }
          if (header.fontSize) {
            doc.setFontSize(header.fontSize);
          }

          doc.text(header.text, header.x, header.y);
        }
      }
    }

    const columnStyles = getDynamicColumnStyles(data.head, data.body);
    autoTable(doc, {
      head: data.head,
      body: data.body,
      styles: {
        cellPadding: 2,
        fontSize: 8,
        overflow: "linebreak",
      },
      columnStyles,
      theme: "striped",
    });

    doc.save(Export.filename + ".pdf");
  };
}

export default Export;
